import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
// ============================================================
// Roles & permissions
// ============================================================
export const AdminRole = z.enum(['admin', 'ops', 'support', 'analyst']);
// ============================================================
// Login / session
// ============================================================
export const AdminLoginRequest = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(128),
});
export const AdminSession = z.object({
    admin_id: z.string(),
    email: z.string().email(),
    role: AdminRole,
    expires_at: IsoDateTime,
});
export const AdminLoginResponse = z.object({
    session: AdminSession,
    jwt: z.string(),
});
export const AdminLogoutResponse = z.object({
    ok: z.literal(true),
});
// ============================================================
// Account record
// ============================================================
export const AdminAccount = z.object({
    admin_id: z.string(),
    email: z.string().email(),
    role: AdminRole,
    active: z.boolean(),
    notes: z.string().nullable(),
    created_at: IsoDateTime,
    last_login_at: IsoDateTime.nullable(),
});
// ============================================================
// Account CRUD (admin role only)
// ============================================================
export const AdminCreateAccountRequest = z.object({
    email: z.string().email(),
    password: z.string().min(12).max(128), // longer minimum for new accounts
    role: AdminRole,
    notes: z.string().max(500).nullable().default(null),
    reason: MutationReason,
});
export const AdminCreateAccountResponse = AdminAccount;
export const AdminUpdateAccountRequest = z.object({
    role: AdminRole.optional(),
    active: z.boolean().optional(),
    notes: z.string().max(500).nullable().optional(),
    reason: MutationReason,
});
export const AdminUpdateAccountResponse = AdminAccount;
export const AdminPasswordResetRequest = z.object({
    new_password: z.string().min(12).max(128),
    reason: MutationReason,
});
export const AdminPasswordResetResponse = z.object({
    ok: z.literal(true),
});
// ============================================================
// Account list
// ============================================================
export const AdminListAccountsRequest = PageRequest.extend({
    role: AdminRole.optional(),
    active: z.boolean().optional(),
    q: z.string().min(1).max(100).optional(), // email substring match
});
export const AdminListAccountsResponse = z.object({
    items: z.array(AdminAccount),
    page: PageMeta,
});
// ============================================================
// Self
// ============================================================
export const AdminMeResponse = AdminAccount;
export const AdminChangeOwnPasswordRequest = z.object({
    current_password: z.string().min(8).max(128),
    new_password: z.string().min(12).max(128),
});
export const AdminChangeOwnPasswordResponse = z.object({
    ok: z.literal(true),
});
//# sourceMappingURL=auth.js.map